import { connect } from 'react-redux';
import { ApplicationState } from '../../../redux/reducers';
import Register from './Register';
import {
  signUp,
  storeSession,
  confirmSignUp,
  login,
  registerIssuer
} from '../../../redux/auth/creators';
import { addToast } from '../../../redux/ui/creators';

interface StateProps {
  auth: any;
}

interface DispatchProps {
  signUp: Function;
  storeSession: Function;
  login: Function;
  confirmSignUp: Function;
  registerIssuer: Function;
  addToast: Function;
}

interface OwnProps {}

export type AllProps = StateProps & DispatchProps & OwnProps;

const mapStateToProps = (state: ApplicationState) => {
  return {
    auth: state.auth
  }
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    signUp: dispatch(signUp),
    storeSession: dispatch(storeSession),
    confirmSignUp: dispatch(confirmSignUp),
    login: dispatch(login),
    registerIssuer: dispatch(registerIssuer),
    addToast: dispatch(addToast),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Register);